<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import SalesDetailCommissionAllocationSummary from './SalesDetailCommissionAllocationSummary.vue';

defineProps({
  recipients: { type: Array, default: () => [] },
  summary: { type: Boolean, default: false },
});
const { t } = useI18n();
const paymentTypes = computed(() => ({
  pix: t('SALES.DETAIL.COMMISSION.PAYMENT_TYPES.PIX'),
  banco: t('SALES.DETAIL.COMMISSION.PAYMENT_TYPES.BANK'),
}));
const money = value => {
  if (value?.amount) return value.amount;
  if (value === null || value === undefined || value === '')
    return t('SALES.DETAIL.EMPTY_VALUE');

  const numeric =
    typeof value === 'number'
      ? value
      : Number(
          String(value)
            .replace(/[R$\s.]/g, '')
            .replace(',', '.')
        );
  return Number.isNaN(numeric)
    ? value
    : new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(numeric);
};
const payment = recipient => {
  const type = recipient.tipo_pagamento === 'banco' ? 'banco' : 'pix';
  const details =
    type === 'pix'
      ? [recipient.chave_pix || recipient.pix]
      : [recipient.nome_banco, recipient.agencia, recipient.numero_conta];
  return [
    paymentTypes.value[type],
    ...(details.filter(Boolean).length
      ? details.filter(Boolean)
      : [t('SALES.DETAIL.COMMISSION.PAYMENT_RESTRICTED')]),
  ].join(' · ');
};
</script>

<template>
  <SalesDetailCommissionAllocationSummary
    v-if="summary"
    :recipients="recipients"
  />
  <div v-else class="overflow-x-auto">
    <table class="min-w-[680px] w-full text-left text-sm">
      <thead
        class="border-b border-lais-border-soft text-xs uppercase tracking-wide text-lais-text-muted"
      >
        <tr>
          <th class="px-3 py-2 font-bold">
            {{ t('SALES.DETAIL.COMMISSION.ALLOCATIONS.NAME') }}
          </th>
          <th class="px-3 py-2 font-bold">
            {{ t('SALES.DETAIL.COMMISSION.ALLOCATIONS.PERCENTAGE') }}
          </th>
          <th class="px-3 py-2 font-bold">
            {{ t('SALES.DETAIL.COMMISSION.ALLOCATIONS.VALUE') }}
          </th>
          <th class="px-3 py-2 font-bold">
            {{ t('SALES.DETAIL.COMMISSION.ALLOCATIONS.PAYMENT') }}
          </th>
        </tr>
      </thead>
      <tbody class="divide-y divide-lais-border-soft text-lais-text-body">
        <tr
          v-for="recipient in recipients"
          :key="recipient.id || recipient.usuario_id"
        >
          <td class="px-3 py-3">
            {{ recipient.name || recipient.nome_empresarial }}
          </td>
          <td class="px-3 py-3">
            {{
              t('SALES.DETAIL.COMMISSION.ALLOCATIONS.PERCENTAGE_VALUE', {
                value: recipient.porcentagem_real,
              })
            }}
          </td>
          <td class="px-3 py-3">{{ money(recipient.valor_real) }}</td>
          <td class="px-3 py-3">{{ payment(recipient) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
